//#region Imports
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@app/core/core.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { WjGridGrouppanelModule } from '@grapecity/wijmo.angular2.grid.grouppanel';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { EnterpriseFormModule } from '@rawlings/enterprise-form';
import { MaterialModule, RawlingsMaterialCoreModule } from '@rawlings/material-core';
import { RawlingsWijmoCoreModule } from '@rawlings/wijmo-core';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ConfirmHealthInsuranceComponent } from './components/confirm-health-insurance/confirm-health-insurance.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { ContactInformationComponent } from './components/contact-information/contact-information.component';
import { FooterContactUsComponent } from './components/layout/footer/footer-contact-us/footer-contact-us.component';
import { FooterFaqComponent } from './components/layout/footer/footer-faq/footer-faq.component';
import { FooterLanguageAccesibilityComponent } from './components/layout/footer/footer-language-accesibility/footer-language-accesibility.component';
import { FooterPrivacyPolicyComponent } from './components/layout/footer/footer-privacy-policy/footer-privacy-policy.component';
import { FooterWhoWeAreComponent } from './components/layout/footer/footer-who-we-are/footer-who-we-are.component';
import { FooterComponent } from './components/layout/footer/footer.component';
import { HeaderComponent } from './components/layout/header/header.component';
import { LoginComponent } from './components/login/login.component';
import { PolicyHolderMemberComponent } from './components/policy-holder-member/policy-holder-member.component';
import { PolicyHolderComponent } from './components/policy-holder/policy-holder.component';
import { OtherHealthInsuranceViewComponent } from './components/summary/other-health-insurance-view/other-health-insurance-view.component';
import { SummaryComponent } from './components/summary/summary.component';
import { SurveyEmploymentStatusComponent } from './components/survey-employment-status/survey-employment-status.component';
import { SurveyOtherBenefitsComponent } from './components/survey-other-benefits/survey-other-benefits.component';
import { SurveyOtherHealthInsuranceComponent } from './components/survey-other-health-insurance/survey-other-health-insurance.component';
import { SurveySocialSecurityBenefitsComponent } from './components/survey-social-security-benefits/survey-social-security-benefits.component';
import { SurveyComponent } from './components/survey/survey.component';
import { initializerPrivayPolicy } from './initializers/privacy-policy.initializer';
import { MemberResponsePortalRouting } from './member-response-portal.routing';
import { MemberResponsePortalComponent } from './page/member-response-portal.component';
import { FooterService } from './service/footer.service';
import { FailedRequestDialogComponent } from './shared/components/failed-request-dialog/failed-request-dialog.component';
import { FailedRequestComponent } from './shared/components/failed-request/failed-request.component';
import { InputPhoneComponent } from './shared/components/input-phone/input-phone.component';
import { MachinifyEnterpriseYesNoComponent } from './shared/components/machinify-enterprise-yes-no/machinify-enterprise-yes-no.component';
import { SessionLogoutDialogComponent } from './shared/components/session-logout-dialog/session-logout-dialog.component';
import { SessionTimeoutDialogComponent } from './shared/components/session-timeout-dialog/session-timeout-dialog.component';
import { ToggleConfirmDialogComponent } from './shared/components/toggle-confirm-dialog/toggle-confirm-dialog.component';
import { UnsavedChangesDialogComponent } from './shared/components/unsaved-changes-dialog/unsaved-changes-dialog.component';
//#endregion Imports
@NgModule({
  declarations: [
    ConfirmationComponent,
    ConfirmDialogComponent,
    ConfirmHealthInsuranceComponent,
    ContactInformationComponent,
    FailedRequestComponent,
    FailedRequestDialogComponent,
    FooterComponent,
    FooterContactUsComponent,
    FooterFaqComponent,
    FooterLanguageAccesibilityComponent,
    FooterPrivacyPolicyComponent,
    FooterWhoWeAreComponent,
    HeaderComponent,
    InputPhoneComponent,
    LoginComponent,
    MemberResponsePortalComponent,
    OtherHealthInsuranceViewComponent,
    PolicyHolderComponent,
    PolicyHolderMemberComponent,
    SessionLogoutDialogComponent,
    SessionTimeoutDialogComponent,
    SummaryComponent,
    SurveyComponent,
    SurveyEmploymentStatusComponent,
    SurveyOtherBenefitsComponent,
    SurveyOtherHealthInsuranceComponent,
    SurveySocialSecurityBenefitsComponent,
    ToggleConfirmDialogComponent,
    UnsavedChangesDialogComponent,
    MachinifyEnterpriseYesNoComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    EnterpriseFormModule,
    FormsModule,
    HttpClientModule,
    MaterialModule,
    MemberResponsePortalRouting,
    RawlingsMaterialCoreModule,
    RawlingsWijmoCoreModule,
    ReactiveFormsModule,
    WjGridFilterModule,
    WjGridGrouppanelModule,
    WjGridModule,
    WjNavModule,
  ],
  exports:[
    MemberResponsePortalComponent
  ],
  providers:[
    FooterService,{
        provide: APP_INITIALIZER,
        useFactory: initializerPrivayPolicy,
        deps: [FooterService],
        multi: true
    }
  ]
})

export class MemberResponsePortalModule {
    public static ForRoot(apiUrl: string, isInsidePivot: boolean = false): ModuleWithProviders<MemberResponsePortalModule> {
        return {
            ngModule: MemberResponsePortalModule,
            providers: [
                {
                    provide: 'BASE_URL',
                    useValue: apiUrl,
                },
                {
                    provide: false,
                    useValue: isInsidePivot
                }
            ],
        };
    }
}
